'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { NAV_LINKS } from '@/lib/nav'
import { cn } from '@/lib/cn'

export function NavLinks({ className, linkClassName }: { className?: string; linkClassName?: string }) {
  const pathname = usePathname()
  return (
    <div className={cn('flex items-center gap-7.5', className)}>
      {NAV_LINKS.map((l) => {
        const active = pathname === l.href
        return (
          <Link
            key={l.href}
            href={l.href}
            aria-current={active ? 'page' : undefined}
            className={cn('font-display text-base font-medium', active && 'font-semibold', linkClassName)}
          >
            {l.label}
          </Link>
        )
      })}
    </div>
  )
}
